import BidEnvelopeIcon from '../../elements/BidEnvelopeIcon/BidEnvelopeIcon'
import BidFacebookIcon from '../../elements/BidFacebookIcon/BidFacebookIcon'
import BidInstagramIcon from '../../elements/BidInstagramIcon/BidInstagramIcon'

type Props = {
  showSearch?: boolean
}

export default function BidSocialIcons({ showSearch }: Props) {
  return (
    <div className={'flex flex-row justify-center items-center gap-2'}>
      <BidFacebookIcon />
      {/*<BidTikTokIcon />*/}
      {/*<BidTwitterIcon />*/}
      <BidInstagramIcon />
      {/*<BidLinkedinIcon />*/}

      <BidEnvelopeIcon />
    </div>
  )
}
